import { useEffect, useState } from "react";
import { Modal } from "./ui";
import { Icon } from "./Icons";
import { pdfBlobUrl } from "../lib/pdf";

/** Preview a pdfmake document in an iframe, with download. `build` returns the
 *  document definition; it's regenerated each time the modal opens. */
export function PdfPreview({ open, onClose, title, filename, build, notice }: {
  open: boolean; onClose: () => void; title: string; filename: string;
  /** May be async — the designer pack pulls mood images down before building. */
  build: () => any | Promise<any>;
  /** Shown above the preview — e.g. a warning about what's in the document. */
  notice?: React.ReactNode;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    let u: string | null = null;
    setBusy(true); setErr(null); setUrl(null);
    Promise.resolve(build())
      .then((doc) => pdfBlobUrl(doc))
      .then((x) => { u = x; setUrl(x); })
      .catch((e) => setErr(String(e?.message || e)))
      .finally(() => setBusy(false));
    return () => { if (u) URL.revokeObjectURL(u); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  function dl() { if (!url) return; const a = document.createElement("a"); a.href = url; a.download = filename; a.click(); }

  return (
    <Modal open={open} onClose={onClose} title={title} wide>
      {notice && <div style={{ marginBottom: 12 }}>{notice}</div>}
      <div style={{ height: notice ? "62vh" : "72vh", borderRadius: 12, overflow: "hidden", border: "1px solid var(--line)", background: "#f4f4f2", display: "grid", placeItems: "center" }}>
        {busy && <div className="dim">Rendering PDF…</div>}
        {err && <div style={{ color: "var(--danger)", fontSize: 13, padding: 20, textAlign: "center" }}>Couldn't render the PDF.<br />{err}</div>}
        {url && !busy && <iframe title="PDF" src={url} style={{ width: "100%", height: "100%", border: "none" }} />}
      </div>
      <div className="row between" style={{ marginTop: 14 }}>
        <span className="dim" style={{ fontSize: 12.5 }}>{filename}</span>
        <div className="row" style={{ gap: 10 }}>
          <button className="btn ghost" onClick={onClose}>Close</button>
          <button className="btn accent" onClick={dl} disabled={!url}><Icon.download width={15} />Download PDF</button>
        </div>
      </div>
    </Modal>
  );
}
